import {
    SettingToDoNotification,
    TaskToDoNotification,
    ToDoNotificationType,
    TaskFolderToDoNotification,
    ToDoNotification,
} from '../schema/ToDoNotification';

export function isSettingToDoNotification(
    notification: ToDoNotification
): notification is SettingToDoNotification {
    return notification?.Type === ToDoNotificationType.Setting;
}

export function isTaskToDoNotification(
    notification: ToDoNotification
): notification is TaskToDoNotification {
    return notification?.Type === ToDoNotificationType.Task;
}

export function isTaskFolderToDoNotification(
    notification: ToDoNotification
): notification is TaskFolderToDoNotification {
    return notification?.Type === ToDoNotificationType.TaskFolder;
}

export function isToDoNotification(notification: any): notification is ToDoNotification {
    return (
        isSettingToDoNotification(notification) ||
        isTaskToDoNotification(notification) ||
        isTaskFolderToDoNotification(notification)
    );
}
